var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 21 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--c-dark-blue3)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.205 13.842v2.022a1.35 1.35 0 0 1-1.47 1.349 13.35 13.35 0 0 1-5.819-2.07 13.15 13.15 0 0 1-4.046-4.046A13.34 13.34 0 0 1 3.8 5.251a1.35 1.35 0 0 1 1.342-1.47h2.023a1.35 1.35 0 0 1 1.349 1.16c.085.647.243 1.283.472 1.895a1.35 1.35 0 0 1-.304 1.423l-.856.856a10.8 10.8 0 0 0 4.045 4.046l.857-.857a1.35 1.35 0 0 1 1.423-.303 8.7 8.7 0 0 0 1.894.472 1.35 1.35 0 0 1 1.16 1.369"
  })));
};
export default SvgPhone;